export default {
  COACH: "$2b$10$ozAiCXwGFMUucSxmi6AH9e9dqIReBisyBTjLs2xj2KVMZtxjvfOK6",
  CUSTOMER: "$2b$10$ozAiCXwGFMUucSxmi6AH9eoC7afvTULKDcdonAT7PP52N28Li9uhm",
  COACH_NAME: "coach",
  CUSTOMER_NAME: "customer",
};
